import axiosInstance from "../Axios/axios";
import { messageConstants } from "../Constants/messageConstant";

export const GetConversations = (user_id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: messageConstants.LOADING,
        isLoading: true,
      });
      const response = await axiosInstance.get(
        `/messenger/conversation/${user_id}`
      );
      if (response) {
        dispatch({
          type: messageConstants.GET_MESSAGES,
          payload: { messages: response.data },
        });
        dispatch({
          type: messageConstants.LOADING,
          isLoading: false,
        });
      }
    } catch (e) {
      dispatch({
        type: messageConstants.LOADING,
        isLoading: false,
      });
    }
  };
};

export const addMessageBySystemUser = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: messageConstants.LOADING,
        isLoading: true,
      });
      const response = await axiosInstance.post(
        "/messages/add-by-system-user",
        data
      );
      if (response) {
        dispatch({
          type: messageConstants.RESPONSE,
          response: {
            state: "SUCCESS",
            message: "Message sent",
          },
        });
        dispatch({
          type: messageConstants.LOADING,
          isLoading: false,
        });
      }
    } catch (e) {
      dispatch({
        type: messageConstants.RESPONSE,
        response: {
          state: "ERROR",
          message: e?.response?.data.message ?? "Connection failed. Try again later",
        },
      });
      dispatch({
        type: messageConstants.LOADING,
        isLoading: false,
      });
    }
  };
};
export const sendMessageToMembersBySystemUser = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: messageConstants.LOADING,
        isLoading: true,
      });
      const response = await axiosInstance.post(
        "/messages/admin-message-to-member",
        data
      );
      if (response) {
        dispatch({
          type: messageConstants.RESPONSE,
          response: {
            state: "SUCCESS",
            message: "Message sent",
          },
        });
        dispatch({
          type: messageConstants.LOADING,
          isLoading: false,
        });
      }
    } catch (e) {
      dispatch({
        type: messageConstants.RESPONSE,
        response: {
          state: "ERROR",
          message: e?.response?.data.message ?? "Connection failed. Try again later",
        },
      });
      dispatch({
        type: messageConstants.LOADING,
        isLoading: false,
      });
    }
  };
};

export const EditMessageBySystemUser = (data,message_id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: messageConstants.LOADING,
        isLoading: true,
      });
      const response = await axiosInstance.put(
        `/messages/edit-by-system-user/${message_id}`,
        data
      );
      if (response) {
        dispatch({
          type: messageConstants.RESPONSE,
          response: {
            state: "SUCCESS",
            message: "Message edited",
          },
        });
        dispatch({
          type: messageConstants.LOADING,
          isLoading: false,
        });
      }
    } catch (e) {
      dispatch({
        type: messageConstants.RESPONSE,
        response: {
          state: "ERROR",
          message: e?.response?.data.message ?? "Connection failed. Try again later",
        },
      });
      dispatch({
        type: messageConstants.LOADING,
        isLoading: false,
      });
    }
  };
};
export const DeleteMessageBySystemUser = (data,message_id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: messageConstants.LOADING,
        isLoading: true,
      });
      const response = await axiosInstance.delete(
        `/messages/delete-by-system-user/${message_id}`,
        data
      );
      if (response) {
        dispatch({
          type: messageConstants.RESPONSE,
          response: {
            state: "SUCCESS",
            message: "Message deleted",
          },
        });
        dispatch({
          type: messageConstants.LOADING,
          isLoading: false,
        });
      }
    } catch (e) {
      dispatch({
        type: messageConstants.RESPONSE,
        response: {
          state: "ERROR",
          message: e?.response?.data.message ?? "Connection failed. Try again later",
        },
      });
      dispatch({
        type: messageConstants.LOADING,
        isLoading: false,
      });
    }
  };
};

export const GetMessagesByDepartment = (department) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: messageConstants.LOADING,
        isLoading: true,
      });

      const response = await axiosInstance.get(
        `/messages/department/${department}`
      );
      if (response) {
        dispatch({
          type: messageConstants.GET_MESSAGES,
          payload: { messages: response.data },
        });
        dispatch({
          type: messageConstants.LOADING,
          isLoading: false,
        });
      }
    } catch (e) {
      dispatch({
        type: messageConstants.LOADING,
        isLoading: false,
      });
    }
  };
};
export const GetLoanOfficersMessagesUnread = (department) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: messageConstants.LOADING,
        isLoading: true,
      });

      const response = await axiosInstance.get(
        `/messages/loan-officers-total`
      );
      if (response) {
        dispatch({
          type: messageConstants.LOAN_OFFICERS_UNREAD,
          payload: { loanMessagesUnread: response.data },
        });
        dispatch({
          type: messageConstants.LOADING,
          isLoading: false,
        });
      }
    } catch (e) {
      dispatch({
        type: messageConstants.LOADING,
        isLoading: false,
      });
    }
  };
};
export const GetMartOfficersMessagesUnread = (department) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: messageConstants.LOADING,
        isLoading: true,
      });

      const response = await axiosInstance.get(
        `/messages/mart-officers-total`
      );
      if (response) {
        dispatch({
          type: messageConstants.MART_OFFICERS_UNREAD,
          payload: { martMessagesUnread: response.data },
        });
        dispatch({
          type: messageConstants.LOADING,
          isLoading: false,
        });
      }
    } catch (e) {
      dispatch({
        type: messageConstants.LOADING,
        isLoading: false,
      });
    }
  };
};

// Departments whose member conversations the support desk works from.
// Customer Service is the desk's own queue; Loan Officer is included because
// the desk is the front door for member loan queries and that is where members
// actually write today (see nurses-portal MessageAdmin.js).
//
// Mart Officer is commented out: the mart desk works its own inbox, so those
// conversations are deliberately kept out of /support/messages. Uncomment to
// bring them back — this list drives the fetch, the department chips and the
// socket rooms, so nothing else needs changing.
//
// NOTE: these are the SAME conversation documents the loans inbox shows. Read
// state is a single flag per chat entry, so marking one read here also clears
// it for that department's own inbox.
export const SUPPORT_INBOX_DEPARTMENTS = [
  "Customer Service",
  "Loan Officer",
  // "Mart Officer",
];

// Fetches every support-visible department in parallel and merges them into one
// list. Each department is fetched independently so one failing endpoint cannot
// empty the whole inbox.
export const GetSupportInboxMessages = (
  departments = SUPPORT_INBOX_DEPARTMENTS
) => {
  return async (dispatch) => {
    try {
      dispatch({ type: messageConstants.LOADING, isLoading: true });

      const results = await Promise.all(
        departments.map((department) =>
          axiosInstance
            .get(`/messages/department/${encodeURIComponent(department)}`)
            .then((res) => res?.data ?? [])
            .catch(() => [])
        )
      );

      // A conversation could in principle be returned by more than one
      // department query; keep the first occurrence.
      const seen = new Set();
      const merged = results
        .flat()
        .filter((m) => {
          const id = String(m?._id ?? "");
          if (!id || seen.has(id)) return false;
          seen.add(id);
          return true;
        })
        .sort((a, b) => new Date(b?.updated_at) - new Date(a?.updated_at));

      dispatch({
        type: messageConstants.GET_MESSAGES,
        payload: { messages: merged },
      });
      dispatch({ type: messageConstants.LOADING, isLoading: false });
    } catch (e) {
      dispatch({ type: messageConstants.LOADING, isLoading: false });
    }
  };
};

// Unread counter for the Customer Service inbox badge. The endpoint returns a
// plain number (unlike /messages/loan-officers-total, which returns an array).
export const GetCustomerServiceMessagesUnread = () => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `/messages/customer-service-total`
      );
      if (response) {
        dispatch({
          type: messageConstants.CUSTOMER_SERVICE_UNREAD,
          payload: { supportMessagesUnread: response.data },
        });
      }
    } catch (e) {
      // Badge only — a failure here must not surface an error on every page.
    }
  };
};

export const getMessageDetailed = (chat_id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: messageConstants.LOADING,
        isLoading: true,
      });

      const response = await axiosInstance.get(
        `/messenger/conversation-detail/${chat_id}`
      );
      if (response) {
        dispatch({
          type: messageConstants.GET_MESSAGE_DETAILED,
          payload: { messageDetailed: response.data },
        });
        dispatch({
          type: messageConstants.LOADING,
          isLoading: false,
        });
      }
    } catch (e) {
      dispatch({
        type: messageConstants.LOADING,
        isLoading: false,
      });
    }
  };
};


// Background action — intentionally silent so it does not write to the shared
// message `response` state (other pages toast on that, which leaked across navigation).
export const MarkMessageAsRead = (message_id, chat_id) => {
  return async (dispatch) => {
    try {
      await axiosInstance.put(
        `/messages/mark-system-user-as-read/${message_id}?chat_id=${chat_id}`
      );
    } catch (e) {
      console.error("Failed to mark message as read", e);
    }
  };
};

// Background action — intentionally silent (see MarkMessageAsRead note above).
export const MarkMessageAsUnread = (message_id, chat_id) => {
  return async (dispatch) => {
    try {
      await axiosInstance.put(
        `/messages/mark-system-user-as-unread/${message_id}?chat_id=${chat_id}`
      );
    } catch (e) {
      console.error("Failed to mark message as unread", e);
    }
  };
};

//   export const GetUsersForChat = () => {
//     return async (dispatch) => {
//       try {
//         dispatch({
//           type: messageConstants.LOADING,
//           isLoading: true,
//         });

//         const response = await axiosInstance.get(
//           `/messenger/users`
//         );
//         if (response) {
//           dispatch({
//             type: messageConstants.GET_USERS_FOR_CHAT,
//             payload: { usersForChat: response.data },
//           });
//           dispatch({
//             type: messageConstants.LOADING,
//             isLoading: false,
//           });
//         }
//       } catch (e) {
//         dispatch({
//           type: messageConstants.LOADING,
//           isLoading: false,
//         });
//       }
//     };
//   };

// export const addMessages = (data) => {
//     return async (dispatch) => {
//       try {
//         dispatch({
//           type: messageConstants.LOADING,
//           isLoading: true,
//         });
//         const response = await axiosInstance.post("/messenger/messages", data);
//         if (response) {
//           dispatch({
//             type: messageConstants.GET_MESSAGES,
//             payload: response.data,
//           });
//           dispatch({
//             type: messageConstants.LOADING,
//             isLoading: false,
//           });
//         }
//       } catch (e) {
//         dispatch({
//           type: messageConstants.LOADING,
//           isLoading: false,
//         });
//       }
//     };
//   };

export const ResetMessagesResponse = () => {
  return async (dispatch) => {
    dispatch({
      type: messageConstants.RESPONSE,
      response: {
        state: null,
        message: "",
      },
    });
  };
};
